import { JSONLD } from 'lincd-jsonld/utils/JSONLD';
import { createNameSpace } from 'lincd/utils/NameSpace';
import { linkedOntology } from '../package.js';
//import all the exports of this file as one variable called _this (we need this at the end)
import * as _this from './profile-plus.js';
/**
 * Load the data of this ontology into memory, thus adding the properties of the entities of this ontology to the local graph.
 */
export var loadData = () => {
    if (typeof module !== 'undefined' && typeof exports !== 'undefined') {
        // CommonJS import
        return import('../data/profile-plus.json').then((data) => JSONLD.parse(data));
    }
    else {
        // ESM import
        //@ts-ignore
        return import('../data/profile-plus.json', { with: { type: 'json' } }).then((data) => JSONLD.parse(data.default));
    }
};
/**
 * The namespace of this ontology, which can be used to create NamedNodes with URI's not listed in this file
 */
export var ns = createNameSpace('http://lincd.org/ont/profile-plus/');
/**
 * The NamedNode of the ontology itself
 */
export var _self = ns('');
//A list of all the entities (Classes & Properties) of this ontology, each exported as a NamedNode
export var smokingHabit = ns('smokingHabit');
export var drinkFrequency = ns('drinkFrequency');
export var fourTwentyFriendly = ns('fourTwentyFriendly');
export var workoutFrequency = ns('workoutFrequency');
export var hasPassion = ns('hasPassion');
export var hasBelief = ns('hasBelief');
export var hasSystemIdeology = ns('hasSystemIdeology');
export var hasCoreValue = ns('hasCoreValue');
export var hasSpiritualPractice = ns('hasSpiritualPractice');
export var hasSacredText = ns('hasSacredText');
export var hasMayanAstrology = ns('hasMayanAstrology');
export var hasChineseZodiac = ns('hasChineseZodiac');
export var hasPersonalityType = ns('hasPersonalityType');
export var hasSpiritualJourney = ns('hasSpiritualJourney');
export var hasLoveLanguage1 = ns('hasLoveLanguage1');
export var hasLoveLanguage2 = ns('hasLoveLanguage2');
export var hasLoveLanguage3 = ns('hasLoveLanguage3');
export var hasLoveLanguage4 = ns('hasLoveLanguage4');
export var hasLoveLanguage5 = ns('hasLoveLanguage5');
export var profileSetupComplete = ns('profileSetupComplete');
export var enabledNotifications = ns('enabledNotifications');
export var enabledLocationServices = ns('enabledLocationServices');
export var UserAccount = ns('UserAccount');
export var BlockAction = ns('BlockAction');
export var profilePicture = ns('profilePicture');
export var languagePreference = ns('languagePreference');
// Peace Flame (plan 003) — anonymous-action claim flow:
// stable per-device cookie used to look up the guest UserAccount for an
// anonymous visitor. Cleared on signin-merge.
export var deviceId = ns('deviceId');
//An extra grouping object so all the entities can be accessed from the prefix/name
export const profilePlus = {
    smokingHabit,
    drinkFrequency,
    fourTwentyFriendly,
    languagePreference,
    workoutFrequency,
    hasPassion,
    hasBelief,
    hasSystemIdeology,
    hasCoreValue,
    hasSpiritualPractice,
    hasSacredText,
    hasMayanAstrology,
    hasChineseZodiac,
    hasPersonalityType,
    hasLoveLanguage1,
    hasLoveLanguage2,
    hasLoveLanguage3,
    hasLoveLanguage4,
    hasLoveLanguage5,
    hasSpiritualJourney,
    profileSetupComplete,
    enabledNotifications,
    enabledLocationServices,
    UserAccount,
    BlockAction,
    profilePicture,
    // Peace Flame (plan 003)
    deviceId,
};
//Registers this ontology to LINCD.JS, so that data loading can be automated amongst other things
linkedOntology(_this, ns, 'profile-plus', loadData, '../data/profile-plus.json');
//# sourceMappingURL=profile-plus.js.map